import { FC, useEffect, useState } from 'react';

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui';

import { useModalStore } from '@/store/use-modal-store';

export default function GuideModal() {
  const isOpen = useModalStore((state) => state.isGuideModalOpen);
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) =>
        useModalStore.setState({ isGuideModalOpen: open })
      }
    >
      <DialogContent className="gap-0 border border-border bg-background p-0 sm:max-w-md sm:rounded-none">
        <DialogHeader className="px-5 pt-6">
          <DialogTitle className="text-xl text-foreground">
            You are trying to connect a new address
          </DialogTitle>
        </DialogHeader>

        <div className="relative p-5 text-lg">
          <div className="pb-2">To add a new address </div>
          - Open your wallet. <br />
          - Choose an address to add. <br />- Connect an account.
          <div className="py-5">
            Thanks for your patience. Since wallet providers don’t allow
            programmatic address switching, this must be done manually.
          </div>
          <a
            href="https://support.metamask.io/configure/accounts/switching-accounts-in-metamask/"
            target="_blank"
            className="text-primary hover:underline"
          >
            How to Switch Accounts in MetaMask
          </a>
        </div>
        <DialogFooter>
          <Button
            type="submit"
            className="h-14 w-full rounded-none font-mono text-lg font-normal tracking-wider"
            onClick={() => useModalStore.setState({ isGuideModalOpen: false })}
          >
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
